import React from 'react';
import { Route, Routes } from "react-router-dom";
import routes from 'src/routes';

import ApiSpecPage from 'src/components/pages/ApiSpecPage';
import TestTxnPage from 'src/components/pages/TestTxnPage';
import BankResponseCodesPage from 'src/components/pages/BankResponseCodesPage';
import AVSResultCodesPage from 'src/components/pages/AVSResultCodesPage';
import ApiPage from 'src/components/pages/ApiPage';
import ThreeDSecure from 'src/components/pages/ThreeDSecure';
import ThreeDsPage from 'src/components/pages/ThreeDsPage';
import WebhookPage from 'src/components/pages/WebhookPage';
import HomePage from 'src/components/pages/HomePage';
import CountryCodesPage from 'src/components/pages/CountryCodesPage';
import CurrencyCodesPage from 'src/components/pages/CurrencyCodesPage';

import OverviewPage from 'src/components/pages/TxnAuthkey/OverviewPage';
import GettingStartedPage from './pages/TxnAuthkey/GettingStartedPage';
import TxnAuthkeyPage from 'src/components/pages/TxnAuthkey/TxnAuthkeyPage';
import TxnSimpleJavaScriptPage from 'src/components/pages/TxnAuthkey/TxnSimpleJavaScriptPage';
import TxnAdvancedJavaScriptPage from 'src/components/pages/TxnAuthkey/TxnAdvancedJavaScriptPage';
import TxnAuthenticationIframePage from 'src/components/pages/TxnAuthkey/TxnAuthenticationIframePage';
import TxnIframeFieldsPage from 'src/components/pages/TxnAuthkey/TxnIframeFieldsPage';
import TxnKlarnaPage from 'src/components/pages/TxnAuthkey/TxnKlarnaPage';
import TxnApplePayPage from 'src/components/pages/TxnAuthkey/TxnApplePayPage';
import TxnGooglePayPage from 'src/components/pages/TxnAuthkey/TxnGooglePayPage';
import Txn2PartyPage from 'src/components/pages/TxnAuthkey/Txn2PartyPage';
import TxnHppConfigurationPage from 'src/components/pages/TxnAuthkey/TxnHppConfigurationPage';

import TokenAuthkeyPage from 'src/components/pages/TokenAuthkey/TokenAuthkeyPage';
import TokenSimpleJavaScriptPage from 'src/components/pages/TokenAuthkey/TokenSimpleJavaScriptPage';
import TokenAdvancedJavaScriptPage from 'src/components/pages/TokenAuthkey/TokenAdvancedJavaScriptPage';
import TokenIframeFieldsPage from 'src/components/pages/TokenAuthkey/TokenIframeFieldsPage';
import TokenTwoPartyPage from 'src/components/pages/TokenAuthkey/TokenTwoPartyPage';

import BatchPage from './pages/Batch/BatchPage';
import BillerPage from './pages/Biller/BillerPage';
import TokenPage from './pages/Token/TokenPage';
import PaymentRequestPage from './pages/PaymentRequest/PaymentRequestPage';
import ReportingPage from './pages/Reporting/ReportingPage';
import TwoPartyTxnProcessingPage from './pages/TwoPartyTxnProcessing/TwoPartyTxnProcessingPage';
import AddressVerificationServicePage from './pages/AddressVerificationService/AddressVerificationServicePage';
import OpenAPIGenerator from 'src/components/pages/OpenAPIGenerator';
import QuickStart from 'src/components/pages/QuickStart';

import PluginsPage from './pages/Plugins/PluginsPage';

function Router() {

    return <Routes>
        <Route path={routes.api.batch.root} element={<BatchPage />} />
        <Route path={routes.api.biller.root} element={<BillerPage />} />
        <Route path={routes.api.twopartytoken.root} element={<TokenPage />} />
        <Route path={routes.api.paymentRequest.root} element={<PaymentRequestPage />} />
        <Route path={routes.api.reporting.root} element={<ReportingPage />} />
        <Route path={routes.api.twoPartyTxnProcessing.root} element={<TwoPartyTxnProcessingPage />} />
        <Route path={routes.api.txn.authkey.javascriptSimple} element={<TxnSimpleJavaScriptPage />} />
        <Route path={routes.api.txn.authkey.javascriptAdvanced} element={<TxnAdvancedJavaScriptPage />} />
        <Route path={routes.api.txn.authkey.iframeFields} element={<TxnIframeFieldsPage />} />
        <Route path={routes.api.txn.authkey.klarna} element={<TxnKlarnaPage />} />
        <Route path={routes.api.txn.authkey.applepay} element={<TxnApplePayPage />} />
        <Route path={routes.api.txn.authkey.googlepay} element={<TxnGooglePayPage />} />
        <Route path={routes.api.txn.authkey.avs} element={<AddressVerificationServicePage />} />
        <Route path={routes.api.txn.authkey.authentication} element={<TxnAuthenticationIframePage />} />
        <Route path={routes.api.txn.authkey.overview} element={<OverviewPage />} />
        <Route path={routes.api.txn.authkey.gettingStarted} element={<GettingStartedPage />} />
        <Route path={routes.api.txn.authkey.flow} element={<TxnAuthkeyPage />} />
        <Route path={routes.api.txn.authkey.hpp} element={<TxnHppConfigurationPage />} />
        <Route path={routes.api.twoparty.root} element={<Txn2PartyPage />} />
        <Route path={routes.api.token.authkey.javascriptSimple} element={<TokenSimpleJavaScriptPage />} />                
        <Route path={routes.api.twoPartyTokenProcessing.root} element={<TokenTwoPartyPage />} />
        <Route path={routes.api.token.authkey.javascriptAdvanced} element={<TokenAdvancedJavaScriptPage />} />
        <Route path={routes.api.token.authkey.iframeFields} element={<TokenIframeFieldsPage />} />
        <Route path={routes.api.token.authkey.overview} element={<TokenAuthkeyPage />} />
        <Route path={routes.api.token.authkey.gettingStarted} element={<TokenAuthkeyPage />} />
        <Route path={routes.api.token.authkey.flow} element={<TokenAuthkeyPage />} />
        <Route path={routes.api.spec} element={<ApiSpecPage />} />
        <Route path={routes.api.ThreeDSecure} element={<ThreeDSecure />} />
        <Route path={routes.api.webhooks} element={<WebhookPage />} />
        <Route path={routes.api.root} element={<ApiPage />} />
        <Route path={routes.reference.bankResponseCodes} element={<BankResponseCodesPage />} />
        <Route path={routes.reference.avsResultCodes} element={<AVSResultCodesPage />} />
        <Route path={routes.reference.testMode} element={<TestTxnPage />} />
        <Route path={routes.reference.threeds} element={<ThreeDsPage />} />
        <Route path={routes.reference.countryCodes} element={<CountryCodesPage />} />
        <Route path={routes.reference.currencyCodes} element={<CurrencyCodesPage />} />
        <Route path={routes.root} element={<HomePage />} />
        <Route path={routes.getstarted.openapigenerator} element={<OpenAPIGenerator />} />
        <Route path={routes.getstarted.quickstart} element={<QuickStart />} />
        <Route path={routes.plugins.root} element={<PluginsPage />} />
    </Routes>;

}

export default Router;